import dayjs from 'dayjs';

// TODO put this in graphql api

function toFullName(season: number) {
  return `${season}-${season + 1}`;
}

const FIRST_YEAR = 2017;
// Current school year flips on July 1, so subtracting 6 months from current date means before july we will still show previous year
const CURRENT_YEAR = +dayjs().subtract(6, 'month').format('YYYY');
// Starting April 1 include next school year as an option using same as logic above
const LAST_YEAR = +dayjs().subtract(3, 'month').format('YYYY');
// this is for building class year options
const CLASS_YEAR = CURRENT_YEAR + 5;

export const CURRENT_SCHOOL_YEAR = toFullName(CURRENT_YEAR);

export const SCHOOL_YEARS = Array.from({ length: LAST_YEAR - FIRST_YEAR + 1 }, (_, i) => toFullName(FIRST_YEAR + i));

export const CLASS_YEARS = Array.from({ length: CLASS_YEAR - CURRENT_YEAR + 1 }, (_, i) => CURRENT_YEAR + i);
